module.exports = __webpack_public_path__ + "static/media/waves.399b9b3d.png";